var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.916 7.518H1.834V4.475L12.392 0l10.544 4.528-.02 2.99ZM1.878 18H4.85V8.944h1.515V18h3.023V8.944h1.515V18h2.957V8.944h1.515V18h2.95V8.944h1.515V18h3.038v4.482h1.5V24h-24v-1.518h1.5V18Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BankFilled.c1e8b32319cb8b06a72bf6f2bd4d3fe8.svg";